import { render, staticRenderFns } from "./AssinanteEdit.vue?vue&type=template&id=2378c71a&"
import script from "./AssinanteEdit.vue?vue&type=script&lang=js&"
export * from "./AssinanteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports